export const SENSOR_EVENT_NAME = {
  CLICK_SIGN_UP_BUTTON: 'ClickSignUpButton', // 点击注册按钮
  GET_CODE: 'GetCode', // 获取验证码
  CLICK_LOGIN_BUTTON: 'ClickLoginButton', // 点击登录按钮
  CLICK_HOME_PAGE_BANNER: 'ClickHomePageBanner', // 点击首页banner
  CLICK_TRADE_BUTTON: 'ClickTradeButton', // 点击首页交易按钮
  CLICK_TRADE_SYMBOL: 'ClickTradeSymbol', // 点击交易对
  CLICK_TRADE: 'ClickTrade', // 点击去交易
  SUBMIT_SPOT_ORDER: 'SubmitSpotOrder', // 提交现货委托
  CANCEL_SPOT_ORDER: 'CancelSpotOrder', // 撤销现货委托
  CLICK_DEPOSIT: 'ClickDeposit', // 点击充值
  CLICK_WITHDRAWAL: 'ClickWithdrawal', // 点击提现
  SUBMIT_WITHDRAW: 'SubmitWithdraw', // 提交提现申请
  CLICK_TRANSFER: 'ClickTransfer', // 点击划转
  ASSET_TRANSFER: 'AssetTransfer', // 资产划转
  INVITE_USER: 'InviteUser', // 发起邀请
  CLICK_ID_VERIFICATION: 'ClickIDVerification', // 点击实名认证
  SUBMIT_ID_VERIFICATION: 'SubmitIDVerification', // 提交实名认证
  VIEW_POPUP: 'ViewPopup', // 浏览弹窗
  CLICK_POPUP: 'ClickPopup', // 点击弹窗
  PERSONAL_CENTER: 'PersonalCenter', // 点击个人中心
  ADD_FAVORITE: 'AddFavorite', // 添加自选
  REMOVE_FAVORITE: 'RemoveFavorite', // 删除自选
  CLICK_TOP_BAR: 'ClickTopBar', // 点击顶部导航
  CLICK_BOTTOM_BAR: 'ClickBottomBar', // 点击底部导航
  GET_SUBSCRIBE_COIN_TYPE: 'GetSubscribeCoinType', // 点击理财申购
  SUBMIT_SUBSCRIBE: 'SubmitSubscribe', // 提交理财申购订单
  SUBMIT_REDEEM: 'SubmitRedeem', // 提交赎回订单
  GOTO_PRODUCT: 'GotoProduct', // 去理财产品页
  SUBSCRIBE_HISTORY: 'SubscribeHistory', // launchpad历史页
  SUBSCRIBE_ACTIVITY: 'SubscribeActivity', // launchpad活动列表页
  SUMBIT_PARTICIPATION: 'SubmitAParticipation', // launchpad提交报名
  CLICK_QUALIFICATION: 'ClickQualification', // launchpad点击资格统计
  SUBSCRIBE_FAQ: 'SubscribeFAQ', // launchpad点击常见问题
  SUBSCRIBE_DETAILED_RULES: 'SubscribeDetailedRules', // launchpad点击详细规则
  CLICK_SPOT_ASSET_TODAY_PNL: 'ClickSpotAssetTodayPnl', // 点击现货页“资产分析”入口
  CLICK_SPOT_ASSET_TODAY_PNL_DATEPICKER: 'ClickSpotAssetTodayPnlDatePicker', // 点击资产分析页面日期选择器
  // 1033 需求，交易优化
  CLICK_SPOT_DETAIL: 'ClickSpotDetailPage', // K线相关
  CLICK_SPOT_TOOL: 'ClickTool', // K线相关
  QUOTATION_PERIOD: 'QuotationPeriod', // 行情时间周期选择
  INDICATOR_SELECTION: 'IndicatorSelection', // 指标选择
  SPOTDETAIL_PAGEEXPOSURE: 'SpotDetailPageExposure', // 标的详情模块曝光
  CLICKSPOT_TRADEPAGE: 'ClickSpotTradePage', // 现货下单页元素点击
  BONUS_GIVEAWAY_CLICKJOINNOW: 'ClickJoinNow', // BONUS_GIVEAWAY 点击参与
  BONUS_GIVEAWAY_CLICKJOINNOWFIRST: 'ClickJoinNowFirst', // BONUS_GIVEAWAY 点击弹窗出来的JoinNow
  BONUS_GIVEAWAY_CLICKJOINSUCCESSFULLYRESULT: 'ClickJoinSuccessfullyResult', // BONUS_GIVEAWAY 点击参与结果
  BONUS_GIVEAWAY_CLICKOPENACCOUNT: 'ClickOpenAccount', // BONUS_GIVEAWAY 点击打开账户
  BONUS_GIVEAWAY_CLICKTRANSFERNOW: 'ClickTransferNow', // BONUS_GIVEAWAY 点击划转资金
  BONUS_GIVEAWAY_CLICKSTARTTRADENOW: 'ClickStartTradeNow', // BONUS_GIVEAWAY 点击开始合约之旅
  BONUS_GIVEAWAY_CLICKEXPERIENCEDTRADENOW: 'ClickExperiencedTradeNow', // BONUS_GIVEAWAY 点击称为有经验的交易者
  BONUS_GIVEAWAY_CLICKFUTURESTRADENOW: 'ClickFuturesTradeNow', // BONUS_GIVEAWAY 点击成为合约专家
  BONUS_GIVEAWAY_ClickTradingEveryDay: 'ClickTradingEveryDay', // BONUS_GIVEAWAY 点击每日合约交易
  BONUS_GIVEAWAY_CLICKCLAIM: 'ClickClaim', // BONUS_GIVEAWAY 点击claim
  BONUS_GIVEAWAY_CLICKCLAIMRESULT: 'ClickClaimResult', // BONUS_GIVEAWAY 点击claim结果
  // 合约相关
  OPEN_CONTRACT_TRANSACTION: 'OpenContractTransaction', // 提交合约交易
  OPEN_CONTRACT_TRANSACTION_RESULT: 'OpenContractTransactionResult', // 提交合约交易结果
  CANCEL_CONTRACT_TRANSACTION: 'CancelContractTransaction', // 取消合约交易
  CANCEL_CONTRACT_TRANSACTION_RESULT: 'CancelContractTransactionResult', // 取消合约交易结果
  CLOSE_CONTRACT_TRANSACTION_RESULT: 'CloseContractTransactionResult', // 结束合约交易结果
  CLOSE_CONTRACT_TRANSACTION: 'CloseContractTransaction', // 结束合约交易
  // 任务中心
  CLICK_REWARDS_HUB_ENTRANCE: 'ClickRewardshubentrance',
  CLICK_LUCKY_DRAW: 'ClickLuckydraw',

  // 黑五活动
  BLACK_FRIDAY: {
    ClickExplore: 'ClickExplore', // 点击探索
    ClickHomeNFTBuy: 'ClickHomeNFTBuy', // 点击主页NFTBuy
    ClickFlashSaleBuy: 'ClickFlashSaleBuy', // 点击FlashSaleBuy
    ClickTrade: 'ClickTrade', // 点击TradeToWin
    ClickGoSpace: 'ClickGoSpace', // 点击GoSpace
    ClickEarn: 'ClickEarn', // 点击Earn
    ClickVote: 'ClickVote', // 点击Vote
    ClickShare: 'ClickShare', // 点击Share
    ClickNFTMarket: 'ClickNFTMarket', // 点击Marketplace
    ClickSaveImage: 'ClickSaveImage', // 点击保存图片
    ClickWagmiBuy: 'ClickWagmiBuy', // 购买
    ClickWagmiComfirm: 'ClickWagmiComfirm', // 购买确认
  },
  // 圣诞节活动
  CHRISTMAS: {
    Click_CD_Join: 'Click_CD_Join', // 点击探索
    Click_CD_NFTBuy: 'Click_CD_NFTBuy', // 点击NFTBuy
    Click_CD_Task1: 'Click_CD_Task1', // 点击任务一领取
    Click_CD_Task2: 'Click_CD_Task2', // 点击任务二领取
    Click_CD_Task3: 'Click_CD_Task3', // 点击任务三领取
    Click_CD_Task4: 'Click_CD_Task4', // 点击任务四领取
    Click_CD_party: 'Click_CD_party', // 点击DiscoverNow
    Click_CD_Earn: 'Click_CD_Earn', // 点击Earn
    Click_CD_Share: 'Click_CD_Share', // 点击Share
    Click_CD_NFTMarket: 'Click_CD_NFTMarket', // 点击Marketplace
    Click_CD_SaveImage: 'Click_CD_SaveImage', // 点击保存图片
    Click_CD_Open: 'Click_CD_Open', // 点击开盒
    Click_CD_Useit: 'Click_CD_Useit', // 点击合约体验金使用
    Click_CD_Tradingfee: 'Click_CD_Tradingfee', // 点击交易费用返还
    Click_CD_TradeUSDT: 'Click_CD_TradeUSDT', // 点击四个币种的交易对
  },
  ClickAppDownload: 'ClickAppDownload', // 点击app下载
  BUY_SELL: {
    gateway_page1_enterbox: 'gateway_page1_enterbox', // 进入数值输入页
    gateway_buy: 'gateway_buy', // 交易方向 买
    gateway_sell: 'gateway_sell', // 交易方向 卖
    gateway_trade_currency: 'gateway_trade_currency',
    gateway_trade_crypto: 'gateway_trade_crypto',
    gateway_sell_avaliable: 'gateway_sell_avaliable', // 填充数量
    gateway_sell_transfaer: 'gateway_sell_transfaer', // 资产划转
    gateway_click_history: 'gateway_click_history', // 点击法币历史订单页
    gateway_page2_historyorder: 'gateway_page2_historyorder', // 进入法币历史订单页
    gateway_historyorder_click_buy: 'gateway_historyorder_click_buy', // 历史购买订单
    gateway_historyorder_click_sell: 'gateway_historyorder_click_sell', // 历史卖出订单
    gateway_historyorder_click_filter: 'gateway_historyorder_click_filter', // 历史订单筛选
    gateway_dropdown_currency: 'gateway_dropdown_currency', // 选择法币
    gateway_dropdown_crypto: 'gateway_dropdown_crypto', // 选择币种
    gateway_switch_switchmode: 'gateway_switch_switchmode', // 切换输入框
    gateway_button_confirmbuy: 'gateway_button_confirmbuy', // 确认买
    gateway_button_confirmsell: 'gateway_button_confirmsell', // 确认卖
    gateway_page2_selectchannel: 'gateway_page2_selectchannel', // 选择渠道方
    gateway_page2_selectpaymentmethod: 'gateway_page2_selectpaymentmethod', // 选择支付方式
    gateway_selectchannel: 'gateway_selectchannel', // 选择渠道方
    gateway_selectpaymentmethod: 'gateway_selectpaymentmethod', // 选择支付方式
    gateway_button_channelnext: 'gateway_button_channelnext', // 渠道方选择下一页
    gateway_page3_placeorder: 'gateway_page3_placeorder', // 进入确认下单页
    gateway_checkbox_terms: 'gateway_checkbox_terms', // 交易条款勾选
    gateway_page4_orderdetail: 'gateway_page4_orderdetail', // 进入订单详情页
    gateway_order_status: 'gateway_order_status', // 是否成功
    web_fiatgateway_buy_place_order_page: 'web_fiatgateway_buy_place_order_page',
    web_fiatgateway_sell_place_order_page: 'web_fiatgateway_sell_place_order_page',
    web_fiatgateway_buy_choose_provider: 'web_fiatgateway_buy_choose_provider',
    web_fiatgateway_sell_choose_provider: 'web_fiatgateway_sell_choose_provider',
    web_fiatgateway_buy_confirm_order: 'web_fiatgateway_buy_confirm_order',
    web_fiatgateway_sell_confirm_order: 'web_fiatgateway_sell_confirm_order',
    web_fiatgateway_buy_order_detail: 'web_fiatgateway_buy_order_detail',
    web_fiatgateway_sell_order_detail: 'web_fiatgateway_sell_order_detail',
  },
  P2P: {
    e_p2p_order_pending: 'e_p2p_order_pending',
    e_p2p_order_deal: 'e_p2p_order_deal',
    web_p2p_buy_place_order_page: 'web_p2p_buy_place_order_page',
    web_p2p_sell_place_order_page: 'web_p2p_sell_place_order_page',
    web_p2p_buy_confirm_place: 'web_p2p_buy_confirm_place',
    web_p2p_sell_confirm_place: 'web_p2p_sell_confirm_place',
    web_p2p_buy_pending_payment: 'web_p2p_buy_pending_payment',
    web_p2p_sell_pending_payment: 'web_p2p_sell_pending_payment',
    web_p2p_buy_confirm_payment: 'web_p2p_buy_confirm_payment',
    web_p2p_sell_confirm_payment: 'web_p2p_sell_confirm_payment',
    web_p2p_buy_pending_release: 'web_p2p_buy_pending_release',
    web_p2p_sell_pending_release: 'web_p2p_sell_pending_release',
    web_p2p_buy_order_complete: 'web_p2p_buy_order_complete',
    web_p2p_sell_order_complete: 'web_p2p_sell_order_complete'
  },
  CARDS:{
    click_buy: 'web_fiat_card_buy_coin',
    click_add_bankcard: 'web_fiat_card_add_bankcard',
    click_buy_confirm: 'web_fiat_card_buy_coin_confirmation',
    open_order_detail: 'web_card_buy_order_detail',
  },
  REDPACKET_RECEIVE: 'e_redpacket_receive', // 领取红包事件
  FUTURE_TRANS_COPY: 'e_future_trans_copy', // 合约向跟单划转事件
  COPY_TRANS_FUTURE: 'e_copy_trans_future', // 跟单向合约划转事件
  SPOT_SETTINGS: 'spot_settings', // 现货设置
  SPOT_BUY_CLICK: 'spot_buy_click', // 现货买入
  SPOT_TRANS_CLICK: 'spot_trans_click', // 现货下单点击事件，点击时触发，不限制下单成功
  SPOT_ERROR_REASON: 'spot_error_reason', // 现货下单失败原因，不论前端还是后端
  SPOT_PLACE_ORDER: 'spot_place_order', // 现货下单成功,下单成功时触发
  SPOT_PLACE_ORDER_CLICK: 'spot_place_order_click', // 下单功能点击
  TRADE_ORDERBOOK_CLICK: 'trade_orderbook_click', // 盘口列表
  TRADE_ORDERS_CLICK: 'trade_orders_click', // 订单区域
  Click_Copy_Trading_Video: 'Click_Copy_Trading_Video', // 点击跟单交易视频
  FUTURES_SEARCH_CLICK: 'FuturesSearchClick', // 合约导航交易对点击埋点
  CONTRACT_TRANS_CLICK: 'contract_trans_click', // 提交合约交易，点击开/平仓按钮统计
  CONTRACT_TRANS_SUCCESS: 'contract_trans_success', // 提交合约交易，开/平仓成功统计
  CONTRACT_TRANS_FAIL: 'contract_trans_fail', // 提交合约交易，开/平仓失败统计
  SPOT_SELL_CLICK: 'spot_sell_click', // 现货卖出
  // 注册入金
  Registry_Deposit: {
    web_newuser_nodeposit_task_card_page: 'web_newuser_nodeposit_task_card_page', //新手注册欢迎页面埋点
    web_newuser_signup_autogift_popup: 'web_newuser_signup_autogift_popup', //弹窗埋点
    web_newuser_signup_autogift_popup_click_button_deposit: 'web_newuser_signup_autogift_popup_click_button_deposit', //入金按钮点击埋点
    web_newuser_signup_autogift_popup_click_button_close: 'web_newuser_signup_autogift_popup_click_button_close', //关闭点击埋点
    web_addfunds_pop_up: 'web_addfunds_pop_up', //入金弹窗展示埋点
    web_addfunds_page_deposit_click_button: 'web_addfunds_page_deposit_click_button', //充值按钮点击埋点
    web_addfunds_page_p2p_click_button: 'web_addfunds_page_p2p_click_button', //P2P按钮点击埋点
    web_addfunds_page_card_click_button: 'web_addfunds_page_card_click_button', //卡收单按钮点击埋点
    web_addfunds_page_gateway_click_button: 'web_addfunds_page_gateway_click_button', //三方按钮点击埋点
    web_newuser_nodeposit_task_card_page_kyc_verification_pop_up: 'web_newuser_nodeposit_task_card_page_kyc_verification_pop_up', //KYC1弹窗埋点
    web_newuser_nodeposit_task_card_page_kyc_verification_pop_up_click_button_confirm: 'web_newuser_nodeposit_task_card_page_kyc_verification_pop_up_click_button_confirm', //KYC1弹窗确认按钮埋点
    web_newuser_nodeposit_task_card_page_kyc_verification_pop_up_click_button_deposit: 'web_newuser_nodeposit_task_card_page_kyc_verification_pop_up_click_button_deposit', //KYC1弹窗充值按钮埋点
    web_newuser_nodeposit_task_card_page_click_button_deposit: 'web_newuser_nodeposit_task_card_page_click_button_deposit', //入金按钮点击埋点 充值
    web_newuser_nodeposit_task_card_page_click_button_deposit_claim: 'web_newuser_nodeposit_task_card_page_click_button_deposit_claim',
    web_newuser_nodeposit_task_card_page_click_button_spot: 'web_newuser_nodeposit_task_card_page_click_button_spot', //入金按钮点击埋点 现货
    web_newuser_nodeposit_task_card_page_click_button_deposit_spot_claim: 'web_newuser_nodeposit_task_card_page_click_button_deposit_spot_claim',
    web_newuser_nodeposit_task_card_page_click_button_future: 'web_newuser_nodeposit_task_card_page_click_button_future', //入金按钮点击埋点 合约
    web_newuser_nodeposit_task_card_page_click_button_deposit_future_claim: 'web_newuser_nodeposit_task_card_page_click_button_deposit_future_claim',
    web_newuser_nodeposit_task_card_page_click_button_earn: 'web_newuser_nodeposit_task_card_page_click_button_earn', // 入金按钮点击埋点 earn
    web_newuser_nodeposit_task_card_page_click_button_deposit_earn_claim: 'web_newuser_nodeposit_task_card_page_click_button_deposit_earn_claim',
    web_task_reminder_deposit: 'web_task_reminder_deposit', // 充值任务提示浮窗埋点
    web_task_reminder_p2p: 'web_task_reminder_p2p', // P2P任务提示浮窗埋点
    web_task_reminder_card: 'web_task_reminder_card', // 卡收单任务提示浮窗埋点
    web_task_reminder_gateway: 'web_task_reminder_gateway', // 三方任务提示浮窗埋点
  },
}

/**
 * 神策收集数据
 * @param {string} eventName 事件名
 * @param {object} data 数据
 */
export const track = function (eventName: string, data: object) {
  const n = {
    ...data,
  }
  return new Promise((resolve, reject) => {
    try {
      window.sensors && window.sensors.track(eventName, n)
      resolve()
    } catch (error) {
      reject()
    }
  })
}
